import { render } from "./StartBackup.vue?vue&type=template&id=625dc47b&scoped=true"
import script from "./StartBackup.vue?vue&type=script&lang=js"
export * from "./StartBackup.vue?vue&type=script&lang=js"

import "./StartBackup.vue?vue&type=style&index=0&id=625dc47b&lang=scss&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625dc47b"]])

export default __exports__